// extracted by mini-css-extract-plugin
module.exports = {"Icon":"icon_Icon__2kNQ9"};